import styles from './WidgetCard.module.css';

/**
 * Shared card shell for the hero widgets: the wrapper carries the static per-card rotation and
 * position, the inner element runs the float bob, `--px` (set by `HeroWidgets`) scales every value.
 */
export default function WidgetCard({left, top, width, rotate, floatDuration, floatDelay, playing, children}) {
    return (
        <div
            className={styles.wrapper}
            style={{
                left: `calc(var(--px) * ${left})`,
                top: `calc(var(--px) * ${top})`,
                width: `calc(var(--px) * ${width})`,
                transform: `rotate(${rotate}deg)`,
            }}
        >
            <div
                className={playing ? styles.float : undefined}
                style={playing ? {animationDuration: `${floatDuration}s`, animationDelay: `${floatDelay}s`} : undefined}
            >
                <div className={styles.card}>{children}</div>
            </div>
        </div>
    );
}
